/* FULL REVIEWS 2026-10-14 (owner: "it says 5,000 reviews but only shows 4 pages").
   sections/pt-reviews.liquid server-renders the first 48 cards (+ one page per star level) from ptr.reviews, which
   holds the first 200 of the product's arranged list. When the product has ptr.full, the section carries
   data-ptr-full = its review FAMILY's whole list (a Shopify Files JSON written by the review build; one file per
   family). The cards the server rendered stay first, in the server's order (so page one never changes and the
   product's own reviews still lead); the family file supplies everything after them, minus those cards. This file:
     - starts fetching it when the reviews are within ~800px of the screen (usually done before the first click);
     - once it has arrived, takes over the grid in whatever state the shopper left it (filter, sort, page, phone
       "show more"), and from then on every filter / sort / page is computed in memory and only the visible cards
       are built (5,025 reviews never become 5,025 DOM nodes);
     - if it cannot be fetched, nothing changes: the server-rendered cards keep working as before.
   Card markup mirrors pt-reviews.liquid exactly. Review text is set with textContent, never as HTML. */
(function () {
  'use strict';

  var VERIFIED = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="8" cy="8" r="8" fill="currentColor"/><path d="M4.4 8.2l2.3 2.3 4.9-4.9" fill="none" stroke="#fff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>Verified';
  var SORTS = {
    recent: function (a, b) { return String(b.d).localeCompare(String(a.d)); },
    oldest: function (a, b) { return String(a.d).localeCompare(String(b.d)); },
    high: function (a, b) { return b.r - a.r; },
    low: function (a, b) { return a.r - b.r; },
    pics: function (a, b) { return pc(b) - pc(a); }
  };
  function pc(x) { return x.pc != null ? x.pc : (x.p ? x.p.length : 0); }
  /* review text arrives as stored by Judge.me; decode entities and drop tags before it is set as TEXT */
  var TA = document.createElement('textarea');
  function txt(s) {
    s = String(s == null ? '' : s);
    if (s.indexOf('&') < 0 && s.indexOf('<') < 0) return s;
    TA.innerHTML = s.replace(/<[^>]*>/g, ' ');
    return TA.value;
  }
  function key(n, b) { return String(n || '').toLowerCase().replace(/[^a-z0-9]/g, '') + '|' + String(b || '').toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 60); }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function mdy(d) {
    var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d || ''));
    return m ? m[2] + '/' + m[3] + '/' + m[1] : '';
  }

  function boot(root) {
    if (root.ptrFullBooted) return;
    root.ptrFullBooted = true;
    var url = root.getAttribute('data-ptr-full');
    var grid = root.querySelector('[data-ptr-grid]');
    var pager = root.querySelector('[data-ptr-pager]');
    if (!url || !grid || !pager) return;
    var perDesk = parseInt(root.dataset.ptrPer, 10) || 12;
    var perMob = parseInt(root.dataset.ptrPerMobile, 10) || 3;
    var PHONE = window.matchMedia('(max-width: 749.98px)');
    var all = null, filter = 'all', sort = 'default', page = 1, expanded = false, loading = null;

    /* the server's cards, in the server's order: they lead the full list as they are */
    var head = Array.prototype.map.call(grid.querySelectorAll('.ptr__card'), function (c) {
      return {
        el: c, r: parseInt(c.getAttribute('data-ptr-rating'), 10) || 0, d: c.getAttribute('data-ptr-date') || '',
        pc: parseInt(c.getAttribute('data-ptr-pics'), 10) || 0,
        k: key((c.querySelector('.ptr__name') || {}).textContent, (c.querySelector('.ptr__text') || {}).textContent)
      };
    });
    /* the star rows are cloned from server cards of the same rating (the section renders a page of every level) */
    var stars = {};
    Array.prototype.forEach.call(grid.querySelectorAll('.ptr__card'), function (c) {
      var r = c.getAttribute('data-ptr-rating'), s = c.querySelector('.ptr__stars');
      if (s && !stars[r]) stars[r] = s.innerHTML;
    });

    function per() { return (PHONE.matches && !expanded) ? perMob : perDesk; }

    function card(rv) {
      if (rv.el) { rv.el.hidden = false; return rv.el; }
      var a = el('article', 'ptr__card'), pics = rv.p || [], body, who, st, i;
      a.setAttribute('data-ptr-rating', rv.r);
      a.setAttribute('data-ptr-date', rv.d || '');
      a.setAttribute('data-ptr-pics', pics.length);
      a.setAttribute('data-ptr-haspic', pics.length ? '1' : '0');
      if (pics.length) {
        var gal = pics.join('|'), media = el('div', 'ptr__media'), lead = el('button', 'ptr__lead'), img = el('img');
        lead.type = 'button';
        lead.setAttribute('data-ptr-gal', gal);
        lead.setAttribute('data-ptr-i', '0');
        lead.setAttribute('aria-label', pics.length > 1 ? 'Open gallery, ' + pics.length + ' photos' : 'Open photo');
        img.src = pics[0] + '?width=420';
        img.alt = 'Customer photo from a review by ' + txt(rv.n);
        img.loading = 'lazy';
        img.decoding = 'async';
        lead.appendChild(img);
        media.appendChild(lead);
        if (pics.length > 1) {
          var shown = Math.min(pics.length - 1, 3), hidden = pics.length - 1 - shown, strip = el('div', 'ptr__strip');
          for (i = 1; i <= shown; i++) {
            var t = el('button', 'ptr__thumb'), ti = el('img');
            t.type = 'button';
            t.setAttribute('data-ptr-gal', gal);
            t.setAttribute('data-ptr-i', String(i));
            t.setAttribute('aria-label', i === shown && hidden > 0 ? 'Open gallery, ' + hidden + ' more photos' : 'Open photo ' + (i + 1) + ' of ' + pics.length);
            ti.src = pics[i] + '?width=150';
            ti.alt = '';
            ti.loading = 'lazy';
            ti.decoding = 'async';
            t.appendChild(ti);
            if (i === shown && hidden > 0) t.appendChild(el('span', 'ptr__more', '+' + hidden));
            strip.appendChild(t);
          }
          media.appendChild(strip);
        }
        a.appendChild(media);
      }
      body = el('div', 'ptr__body');
      who = el('div', 'ptr__who');
      who.appendChild(el('span', 'ptr__name', txt(rv.n)));
      if (rv.v) { var v = el('span', 'ptr__verified'); v.innerHTML = VERIFIED; who.appendChild(v); }
      body.appendChild(who);
      body.appendChild(el('span', 'ptr__date', mdy(rv.d)));
      st = el('div', 'ptr__stars');
      if (stars[String(rv.r)]) st.innerHTML = stars[String(rv.r)];
      else st.textContent = new Array(rv.r + 1).join('★');
      body.appendChild(st);
      if (rv.t) body.appendChild(el('h3', 'ptr__title', txt(rv.t)));
      body.appendChild(el('p', 'ptr__text', txt(rv.b)));
      a.appendChild(body);
      return a;
    }

    function list() {
      var out = all.filter(function (rv) {
        if (filter === 'all') return true;
        if (filter === 'photos') return pc(rv) > 0;
        return String(rv.r) === filter;
      });
      return SORTS[sort] ? out.slice().sort(SORTS[sort]) : out;   /* stable: ties keep the featured order */
    }

    function render() {
      var shown = list(), size = per(), pages = Math.max(1, Math.ceil(shown.length / size)), frag = document.createDocumentFragment();
      if (page > pages) page = pages;
      shown.slice((page - 1) * size, page * size).forEach(function (rv) { frag.appendChild(card(rv)); });
      grid.innerHTML = '';
      grid.appendChild(frag);
      var empty = root.querySelector('.ptr__none');
      if (!shown.length) {
        if (!empty) { empty = el('p', 'ptr__none'); grid.parentNode.insertBefore(empty, pager); }
        empty.textContent = 'No reviews match that filter.';
      } else if (empty) empty.remove();
      pager.innerHTML = '';
      if (PHONE.matches && !expanded) {
        if (shown.length > perMob) {
          var more = el('button', 'ptr__showall', 'Show more reviews');
          more.type = 'button';
          more.addEventListener('click', function () { expanded = true; page = 1; render(); });
          pager.appendChild(more);
        }
        return;
      }
      if (pages < 2) return;
      function btn(label, target, opts) {
        var b = el('button', null, label);
        b.type = 'button';
        if (opts.current) b.setAttribute('aria-current', 'true');
        if (opts.disabled) b.disabled = true;
        b.addEventListener('click', function () {
          page = target;
          render();
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
        pager.appendChild(b);
      }
      btn('‹', Math.max(1, page - 1), { disabled: page === 1 });
      var start = Math.max(1, page - 2), end = Math.min(pages, start + 4);
      start = Math.max(1, end - 4);
      for (var i = start; i <= end; i++) btn(String(i), i, { current: i === page });
      btn('›', Math.min(pages, page + 1), { disabled: page === pages });
    }

    /* take over in the state the shopper left the server grid in */
    function takeover(json) {
      if (!json || !Array.isArray(json.rv) || !json.rv.length) return;
      var left = {};
      head.forEach(function (h) { left[h.k] = (left[h.k] || 0) + 1; });
      all = head.slice();
      json.rv.forEach(function (rv) {
        var k = key(txt(rv.n), txt(rv.b));
        if (left[k]) { left[k]--; return; }          /* already on the page as a server card */
        all.push(rv);
      });
      var on = root.querySelector('[data-ptr-filter].is-on'), sel = root.querySelector('[data-ptr-sort]'), cur = pager.querySelector('[aria-current]');
      filter = on ? on.getAttribute('data-ptr-filter') : 'all';
      sort = sel ? sel.value : 'default';
      page = cur ? parseInt(cur.textContent, 10) || 1 : 1;
      expanded = !(PHONE.matches && pager.querySelector('.ptr__showall'));
      root.ptrTakeover = true;          /* pt-reviews.liquid's own handlers stand down */
      root.classList.add('ptr--full');
      render();
    }

    function load() {
      if (!loading) {
        loading = fetch(url, { credentials: 'omit' })
          .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('reviews ' + r.status)); })
          .then(takeover)
          .catch(function () { loading = null; });   /* stay on the server cards; a later scroll may retry */
      }
      return loading;
    }

    root.addEventListener('click', function (e) {
      if (!root.ptrTakeover) return;
      var f = e.target.closest('[data-ptr-filter]');
      if (!f) return;
      filter = f.getAttribute('data-ptr-filter');
      page = 1;
      Array.prototype.forEach.call(root.querySelectorAll('[data-ptr-filter]'), function (b) { b.classList.toggle('is-on', b === f); });
      render();
    });
    var sortEl = root.querySelector('[data-ptr-sort]');
    if (sortEl) sortEl.addEventListener('change', function () {
      if (!root.ptrTakeover) return;
      sort = this.value;
      page = 1;
      render();
    });
    var onBP = function () { if (root.ptrTakeover) { page = 1; render(); } };
    if (PHONE.addEventListener) PHONE.addEventListener('change', onBP); else PHONE.addListener(onBP);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (x) { return x.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '800px 0px' });
      io.observe(root);
    } else {
      load();
    }
  }

  function init() { Array.prototype.forEach.call(document.querySelectorAll('[data-ptr-full]'), boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
